module.exports = __webpack_public_path__ + "img/violet_068.9b14264f.png";